export default {
  'scenarios.create.edit_step.header.status_check': 'Edit Health Check',
  'scenarios.create.attacks.save_button.validate_scenario.invalid.no_attack_or_health_check':
    'Add an attack or Health Check to save this scenario',
  'scenarios.create.scenario_step_editor.step_type_options.status_check.title':
    'Add a Health Check',
  'scenarios.create.status_checks.configuration.section.info':
    'Configure the details of your Health Check.',
  'scenarios.create.status_checks.configuration.selected_status_check.text':
    'has been selected from your Health Checks library.',
  'scenarios.create.status_checks.configuration.form.configuration_name.field.label':
    'Health Check Name',
  'scenarios.create.status_checks.configuration.saved_status_checks_import.title':
    'Start from a saved Health Check',
  'scenarios.create.status_checks.configuration.saved_status_checks_import.subtitle':
    'Use a Health Check from your team’s library.',
  'scenarios.create.status_checks.configuration.saved_status_checks_import.link.text':
    'Manage Saved Health Checks',
  'scenarios.create.status_checks.create_status_check.configuration.invalid':
    'Configuration is required to add a Health Check to a scenario',
  'scenarios.create.status_checks.create_status_check.configuration_and_success_evaluation.invalid':
    'Configuration and Success Evaluation are required to add a Health Check to a scenario',
  'scenarios.create.status_checks.create_status_check.success_evaluation.invalid':
    'Success Evaluation is required to add a Health Check to a scenario',
  'scenarios.create.status_checks.success_evaluation.section_title.info.label':
    'Choose success criteria to run a Health Check against.',
  'scenarios.detail.results_form.modal.save_status_check':
    'Save and add Health Check',
  'scenarios.detail.results_form.new_results_form.prompt.add_status_check':
    'Consider adding a Health Check to automate Pass/Fail results.',
  'scenarios.detail.scenario_actions.run_scenario_button.tooltip.text':
    'Add an attack or Health Check to run this scenario',
  'scenarios.detail.scenario_status_check_details_off_canvas.halted_step.checks_label.text':
    'Scenario was halted by this Health Check while executing:',
  'scenarios.detail.scenario_status_check_details_off_canvas.check_overview.image.alt.text':
    'Health Check Gremlin',
  'scenarios.overview.published_scenario_multi_select.title':
    'Allow any team in your company to copy these Scenarios and attack their own targets.',
  'scenarios.overview.published_scenario_multi_select.subtitle':
    'If they contain any Health Checks the copy will include their configurations, headers and success evaluations.',
  'scenarios.overview.status_checks.status_checks_list.empty_data.message.no_search_query':
    'Find and edit your Health Checks here.',
  'scenarios.overview.status_checks.status_checks_list.empty_data.message.with_search_query':
    'We couldn\'t find any Health Checks matching: "{{searchQuery}}"',
  'scenarios.share_scenario_modal.message.paragraph_one':
    'Allow any team in your company to copy this Scenario and attack their own targets. If you added any Health Checks the copy will include their configurations, headers and success evaluations.',
  'scenarios.share_scenario_modal.message.paragraph_two':
    'You can unshare from Recommended Scenarios at any time.',
  'scenarios.share_scenario_modal.title': 'Share a copy with your company'
}
